import {createSlice, PayloadAction} from '@reduxjs/toolkit';
/**
 * types for project analytics data
 */

export type UserPermissions = {
  id: number;
  name: string;
};

export type ProjectInitialStateType = {
  isLoading: boolean;
  errorProjectAnalyticsState: boolean | string;
  successProjectAnalyticsState: boolean | string;
  status: {
    priority_task: number;
    pending_task: number;
    completed_task: number;
    upcoming_task: number;
    total_task: number;
  } | null;
  permissions: UserPermissions[];
};

/**
 * get project dashboard
 */
export type getDashboardRequestParams = {
  id: number;
};

export type getDashboardSuccessResponse = {
  status_code: string;
  data: {
    id: number;
    proj_id: string;
    priority_task: number;
    pending_task: number;
    completed_task: number;
    total_task: number;
    upcoming_task: number;
    is_active: boolean;
    status: number;
    permissions: UserPermissions[];
  };
};

const initialState: ProjectInitialStateType = {
  isLoading: false,
  errorProjectAnalyticsState: false,
  successProjectAnalyticsState: false,
  status: null,
  permissions: [],
};

const ProjectAnalyticsSlice = createSlice({
  name: 'projectsAnalytics',
  initialState,
  reducers: {
    getDashboardRequest(
      state,
      action: PayloadAction<getDashboardRequestParams>,
    ) {
      state.isLoading = true;
      state.errorProjectAnalyticsState = false;
      state.successProjectAnalyticsState = false;
    },
    getDashboardFailure(state, action: PayloadAction<string | boolean>) {
      state.isLoading = false;
      state.permissions = [];
    },
    getDashboardSuccess(
      state,
      action: PayloadAction<getDashboardSuccessResponse>,
    ) {
      state.isLoading = false;
      state.status = {
        completed_task: action.payload.data.completed_task,
        pending_task: action.payload.data.pending_task,
        priority_task: action.payload.data.priority_task,
        total_task: action.payload.data.total_task,
        upcoming_task: action.payload.data.upcoming_task,
      };
      state.permissions = action.payload.data.permissions;
    },
    resetMessage(state) {
      state.errorProjectAnalyticsState = false;
      state.successProjectAnalyticsState = false;
    },
  },
});

export default ProjectAnalyticsSlice.reducer;
export const {
  getDashboardFailure,
  getDashboardRequest,
  getDashboardSuccess,
  resetMessage,
} = ProjectAnalyticsSlice.actions;
